const ReconciliationComponent = () => import('@/views/WareHouse/Reconciliation/ReconciliationView')

export default [
    {
        path:'/ReconciliationIndex',
        name:'ReconciliationComponent',
        component:ReconciliationComponent
    }
]